<script setup lang="ts">
    import { useRoute } from 'vue-router';

    defineProps<{
        to: string;
    }>();

    const route = useRoute();
</script>
<template>
    <RouterLink
        :to="to"
        :data-selected="route.path.includes(to)"
        class="custom-focus text-body block rounded-sm px-3 py-2 hover:bg-gray-light/40 data-[selected=true]:bg-gray-lightest data-[selected=true]:hover:bg-gray-lightest"
    >
        <slot />
    </RouterLink>
</template>
